import './FHIRQueryRequestHistory.scss';
import { Base_RequestHistory } from '../../Page_BaseSandbox/Base_RequestHistory/index.js';
import { ModuleFE_SandboxFHIRQuery } from '../../modules/ModuleFE_SandboxFHIRQuery/index.js';
export class FHIRQueryRequestHistory extends Base_RequestHistory {
    getHistory() {
        return ModuleFE_SandboxFHIRQuery.getHistory();
    }
    convertHistoryMessageToPrint(historyMessage) {
        return historyMessage.content;
    }
    clearHistory() {
        ModuleFE_SandboxFHIRQuery.clearHistory();
    }
}
//# sourceMappingURL=FHIRQueryRequestHistory.js.map